import { render, staticRenderFns } from "./Consultorias.vue?vue&type=template&id=30e0efa8"
import script from "./Consultorias.vue?vue&type=script&lang=js"
export * from "./Consultorias.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports